import React from 'react'

type Props = {
  color: string
  size?: 'small' | 'medium' | 'large'
}

const CenterGroupCircle: React.FC<Props> = ({ color, size = 'large' }) => {
  const sizeClasses =
    size === 'small'
      ? 'h-2 min-w-2 w-2'
      : size === 'medium'
        ? 'h-3 min-w-3 w-3'
        : 'h-4 min-w-4 w-4'
  return <div className={`${sizeClasses} rounded-full`} style={{ backgroundColor: color }} />
}

export default CenterGroupCircle
